<div class="card shadow-sm">
  <div class="card-body p-4">
    <!-- Nav tabs using ng-bootstrap -->
    <ul 
      ngbNav 
      #nav="ngbNav" 
      [(activeId)]="activeTabId" 
      (activeIdChange)="onTabChange($event)"
      [class]="'nav-tabs mb-3 ' + tabsClass">
      
      <li [ngbNavItem]="tab.id" *ngFor="let tab of tabs; trackBy: trackByTabId" [disabled]="tab.disabled">
        <a ngbNavLink class="d-flex align-items-center">
          <!-- Icon if provided and showIcons is true -->
          <i *ngIf="showIcons && tab.icon" [class]="tab.icon + ' me-2'"></i>
          
          <!-- Tab title -->
          <span>{{ tab.title }}</span>
          
          <!-- Close button for dynamic tabs -->
          <button 
            *ngIf="allowDynamicTabs && tabs.length > 1" 
            type="button" 
            class="btn-close btn-close-sm ms-2" 
            (click)="removeTab(tab.id, $event)"
            [attr.aria-label]="'Fermer ' + tab.title">
          </button>
        </a>
        
        <ng-template ngbNavContent>
          <div [class]="'tab-pane ' + tabContentClass">
            <!-- Custom template content if provided -->
            <ng-container *ngIf="tab.template; else defaultContent">
              <ng-container *ngTemplateOutlet="tab.template; context: { $implicit: tab }"></ng-container>
            </ng-container>
            
            <!-- Default content template -->
            <ng-template #defaultContent>
              <div class="d-flex mt-3 p-3 bg-light rounded-3">
                <div class="flex-shrink-0" *ngIf="tab.icon">
                  <i [class]="tab.icon + ' fs-4'"></i>
                </div>
                <div class="flex-grow-1" [class.ms-3]="tab.icon">
                  <h6 class="mb-2">{{ tab.title }}</h6>
                  <p class="mb-2" *ngIf="tab.content">{{ tab.content }}</p>
                  <ng-content></ng-content>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-template>
      </li>
    </ul>
    
    <!-- Add tab button -->
    <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="allowDynamicTabs">
      <div></div>
      <button 
        type="button" 
        class="btn btn-outline-primary btn-sm" 
        (click)="addTab()"
        [disabled]="tabs.length >= maxTabs">
        <i class="ri-add-line me-1"></i>
        Ajouter un onglet
      </button>
    </div>
    
    <!-- Tab content outlet -->
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>